// extracted by mini-css-extract-plugin
export default {"Container":"Card_Container__atZyz","Box":"Card_Box__BOcaA","Button":"Card_Button__jXDg5"};